// Allergens and their description
export const alergenMap = [
    { title: "A1", desc: "Obiloviny obsahující lepek a výrobky z něj" },
    { title: "A2", desc: "Korýši a výrobky z nich" },
    { title: "A3", desc: "Vejce a výrobky z nich" },
    { title: "A4", desc: "Ryby a výrobky z nich" },
    { title: "A5", desc: "Obiloviny obsahující lepek a výrobky z něj" },
    { title: "A6", desc: "Sójové boby a výrobky z nich" },
    { title: "A7", desc: "Mléko a výrobky z něj" },
    { title: "A8", desc: "Skořápkové plody a výrobky z nich" },
    { title: "A9", desc: "Celer a výrobky z něj" },
    { title: "A10", desc: "Hořčice a výrobky z ní" },
    { title: "A11", desc: "Sezamová semena (sezam) výrobky z nich" },
    { title: "A12", desc: "Oxid siřičitý a siřičitany" },
    { title: "A13", desc: "Vlčí bob" },
    { title: "A14", desc: "Měkkýši a výrobky z nich" }
];